import { render } from "./Register.vue?vue&type=template&id=c98d56ee&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=c98d56ee&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c98d56ee"]])

export default __exports__